import React, { useState } from 'react';
import './App.css';

const MusicalNotesApp = () => {

  const notes = ['Do', 'Ré', 'Mi', 'Fa', 'Sol', 'La', 'Si'];
  const data = [
    {note: "Do", clé:"sol", valeur:"0", path:"/img/do0_cs.png", level:"facile"},
    {note: "Ré", clé:"sol", valeur:"0", path:"/img/re0_cs.png", level:"facile"},
    {note: "Mi", clé:"sol", valeur:"0", path:"/img/mi0_cs.png", level:"facile"},
    {note: "Fa", clé:"sol", valeur:"0", path:"/img/fa0_cs.png", level:"facile"},
    {note: "Sol",clé:"sol", valeur:"0", path:"/img/sol0_cs.png",level:"facile"},
    {note: "La", clé:"sol", valeur:"0", path:"/img/la0_cs.png", level:"facile"},
    {note: "Si", clé:"sol", valeur:"0", path:"/img/si0_cs.png", level:"facile"},

    {note: "Do", clé:"sol", valeur:"1", path:"/img/do1_cs.png", level:"facile"},
    {note: "Ré", clé:"sol", valeur:"1", path:"/img/re1_cs.png", level:"facile"},
    {note: "Mi", clé:"sol", valeur:"1", path:"/img/mi1_cs.png", level:"facile"},
    {note: "Fa", clé:"sol", valeur:"1", path:"/img/fa1_cs.png", level:"facile"},
    {note: "Sol",clé:"sol", valeur:"1", path:"/img/sol1_cs.png", level:"facile"},
    {note: "La", clé:"sol", valeur:"1", path:"/img/la1_cs.png", level:"facile"},
    {note: "Si", clé:"sol", valeur:"1", path:"/img/si1_cs.png", level:"facile"},

    {note: "Do", clé:"sol", valeur:"2", path:"/img/do2_cs.png", level:"difficile"},
    {note: "Ré", clé:"sol", valeur:"2", path:"/img/re2_cs.png", level:"difficile"},
    {note: "Mi", clé:"sol", valeur:"2", path:"/img/mi2_cs.png", level:"difficile"},
    {note: "Fa", clé:"sol", valeur:"2", path:"/img/fa2_cs.png", level:"difficile"},
    {note: "Sol", clé:"sol", valeur:"2", path:"/img/sol2_cs.png", level:"difficile"},
    {note: "La", clé:"sol", valeur:"2", path:"/img/la2_cs.png", level:"difficile"},
    {note: "Si", clé:"sol", valeur:"2", path:"/img/si2_cs.png", level:"difficile"},

    {note: "Do", clé:"sol", valeur:"-1", path:"/img/do-1_cs.png", level:"difficile"},
    {note: "Ré", clé:"sol", valeur:"-1", path:"/img/re-1_cs.png", level:"difficile"},
    {note: "Mi", clé:"sol", valeur:"-1", path:"/img/mi-1_cs.png", level:"difficile"},
    {note: "Fa", clé:"sol", valeur:"-1", path:"/img/fa-1_cs.png", level:"difficile"},
    {note: "Sol", clé:"sol", valeur:"-1", path:"/img/sol-1_cs.png", level:"difficile"},
    {note: "La", clé:"sol", valeur:"-1", path:"/img/la-1_cs.png", level:"difficile"},
    {note: "Si", clé:"sol", valeur:"-1", path:"/img/si-1_cs.png", level:"difficile"},

    {note: "Do", clé:"fa", valeur:"0", path:"/img/do0_cf.png", level:"difficile"},
    {note: "Ré", clé:"fa", valeur:"0", path:"/img/re0_cf.png", level:"difficile"},
    {note: "Mi", clé:"fa", valeur:"0", path:"/img/mi0_cf.png", level:"difficile"},
    {note: "Fa", clé:"fa", valeur:"0", path:"/img/fa0_cf.png", level:"difficile"},
    {note: "Sol", clé:"fa", valeur:"0", path:"/img/sol0_cf.png", level:"difficile"},
    {note: "La", clé:"fa", valeur:"0", path:"/img/la0_cf.png", level:"difficile"},
    {note: "Si", clé:"fa", valeur:"0", path:"/img/si0_cf.png", level:"difficile"},

    {note: "Do", clé:"fa", valeur:"-1", path:"/img/do-1_cf.png", level:"facile"},
    {note: "Ré", clé:"fa", valeur:"-1", path:"/img/re-1_cf.png", level:"facile"},
    {note: "Mi", clé:"fa", valeur:"-1", path:"/img/mi-1_cf.png", level:"facile"},
    {note: "Fa", clé:"fa", valeur:"-1", path:"/img/fa-1_cf.png", level:"facile"},
    {note: "Sol",clé:"fa", valeur:"-1", path:"/img/sol-1_cf.png",level:"facile"},
    {note: "La", clé:"fa", valeur:"-1", path:"/img/la-1_cf.png", level:"facile"},
    {note: "Si", clé:"fa", valeur:"-1", path:"/img/si-1_cf.png", level:"facile"},

    {note: "Do", clé:"fa", valeur:"-2", path:"/img/do-2_cf.png", level:"facile"},
    {note: "Ré", clé:"fa", valeur:"-2", path:"/img/re-2_cf.png", level:"facile"},
    {note: "Mi", clé:"fa", valeur:"-2", path:"/img/mi-2_cf.png", level:"facile"},
    {note: "Fa", clé:"fa", valeur:"-2", path:"/img/fa-2_cf.png", level:"facile"},
    {note: "Sol",clé:"fa", valeur:"-2", path:"/img/sol-2_cf.png",level:"facile"},
    {note: "La", clé:"fa", valeur:"-2", path:"/img/la-2_cf.png", level:"facile"},
    {note: "Si", clé:"fa", valeur:"-2", path:"/img/si-2_cf.png", level:"facile"},
  ];

  const levels = ["Clé de sol", "Clé de fa", "Difficile"];

  const [inhibited,setInhibited] = useState(false);
  const [scoreOk, setScoreOk] = useState(0);
  const [scoreFail, setScoreFail] = useState(0);
  const [checkedLevels, setCheckedLevels] = useState({"Clé de sol": true});
  const [noteStyle, setNoteStyle] = useState(
                                    Array(7).fill("noteButtonNotSelected"));
  const [currentNoteIndex, setCurrentNoteIndex] = useState(0); 

  const currentIndexToUniversalIndex = (ci) => {
      let result = notes.indexOf(data[ci].note);
      if (result === -1) {
        result = 0;
      }
      return result;
  }

  const updateNote = () => {
      let  i = currentNoteIndex; 
      let maxTry = 100
      while(maxTry > 0) {
          i = Math.floor(Math.random()*data.length);
          if(i !== currentNoteIndex) {
            if((data[i].clé === "sol" && checkedLevels["Clé de sol"] === true)||
            (data[i].clé === "fa" && checkedLevels["Clé de fa"] === true)) {
              if(((data[i].level) === "facile") || 
                (checkedLevels["Difficile"] === true))
              {
                  break;    
              }
            }
          }
      }
      setCurrentNoteIndex(i);
      resetNoteStyle();
  }    

  const resetNoteStyle = () => {
      setInhibited(false);
      setNoteStyle(Array(7).fill("noteButtonNotSelected"));
  }

  const handleSuccess = (index) => {
      setScoreOk(scoreOk + 1);
      let ns = noteStyle;
      ns[index] = "noteButtonOk";
      console.log(ns);
      setNoteStyle(ns);
      setTimeout(updateNote,1200);
  };

  const handleFail = (index) => {
      setScoreFail(scoreFail + 1);
      let ns = noteStyle;
      ns[index] = "noteButtonWrong";
      let okIndex = currentIndexToUniversalIndex(currentNoteIndex);
      ns[okIndex] = "noteButtonOk"; 
      setNoteStyle(ns);
      setTimeout(resetNoteStyle,2000);
  };

  const handleNoteClick = (note,index) => {
    if(!inhibited){
      setInhibited(true);
      if(note === data[currentNoteIndex].note) {
        handleSuccess(index);
      }
      else {
        handleFail(index);
      }
    }
  };

  const handleChangeLevel = (event) => {
    const { name, checked } = event.target;
    setCheckedLevels({
      ...checkedLevels,
      [name]: checked,
    });

    console.log(checkedLevels);
  };

  return (
    <div className="main">
      <h1>Lecture de notes</h1>
      <img className="displayedNote" src={data[currentNoteIndex].path} 
      alt="Portée musicale"/>

      <div className="noteButtonDiv">
        {notes.map((note, index) => (
          <button
            key={index}
            onClick={() => handleNoteClick(note,index)}
            className={noteStyle[index]}
          >
            {note}
          </button>
        ))}
      </div>
      <div>
        <ul>
          {levels.map((item, index) => (
          <li key={index}>
            <label>
              <input
                type="checkbox"
                name={item}
                checked={checkedLevels[item] || false}
                onChange={handleChangeLevel}
              />
              {item}
            </label>
          </li>
        ))}
        </ul>
      </div>
      <div>
        <p>{scoreOk > 1 ? "Bonnes réponses":"Bonne réponse"} : {scoreOk}</p>
        <p>
         {scoreFail > 1 ? "Mauvaises réponses":"Mauvaise réponse"} : {scoreFail}
        </p>
      </div>
    </div>
  );
};

export default MusicalNotesApp;
